/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Packaging_Deducted_TitleInputs */

const vi_order_packaging_deducted_title = /** @type {(inputs: Order_Packaging_Deducted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vật tư bao bì đã trừ`)
};

/**

* @param {Order_Packaging_Deducted_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_packaging_deducted_title = /** @type {((inputs?: Order_Packaging_Deducted_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Packaging_Deducted_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_packaging_deducted_title(inputs)
});